import headers from "app/requests/headers";

export const create = (params) => (
  fetch("/api/public/session", {
    body: JSON.stringify(params),
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);

export const destroy = () => (
  fetch("/api/public/session", {
    headers: headers(),
    method: "DELETE"
  }).then((response) => response.json())
);

export const forgotPassword = (params) => (
  fetch("/api/public/forgot_password", {
    body: JSON.stringify(params),
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);
